// This file need to be removed or changed once we get global styles
// for switch checkbox from lakshmi and team
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';
export const StyledCheckBoxDiv = styled.div`
  width: auto;
  .checkbox-switch-wrapper {
    display: flex;
    align-items: center;
  }

  .checkbox-switch {
    display: inline-block;
    width: ${toRem(52)};
    height: ${toRem(32)};
    position: relative;
    margin-right: ${toRem(8)};
  }

  .checkbox-switch + input {
    opacity: 0;
  }

  .checkbox-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${baseVariables.color['black']};
    transition: 0.4s;
    border-radius: ${toRem(34)};
    border: ${toRem(1)} solid ${baseVariables.color['light-gray-3']};
  }

  .checkbox-slider:before {
    position: absolute;
    content: '';
    height: ${toRem(28)};
    width: ${toRem(28)};
    left: ${toRem(0.5)};
    top: ${toRem(1)};
    background-color: ${baseVariables.color['light-gray-3']};
    transition: 0.4s;
    border-radius: ${toRem(34)};
    border: none;
  }

  input[type='checkbox']:checked + .checkbox-slider {
    background-color: ${baseVariables.color['light-orange-2']};
    border-color: ${baseVariables.color['light-orange-2']};
  }

  input[type='checkbox']:checked + .checkbox-slider:before {
    background-color: ${baseVariables.color['light-gray-3']};
    transform: translateX(${toRem(19)});
    border-radius: 50%;
    left: ${toRem(2)};
  }
`;
